import { defineMessages } from 'react-intl';

export default defineMessages({
  free: {
    id: 'utils.free',
    description: 'Free text',
    defaultMessage: 'Free',
  },
  nightTrial100: {
    id: 'utils.nightTrial100',
    defaultMessage: '100-Night Trial',
  },
  nightTrial100Description: {
    id: 'utils.nightTrial100Description',
    defaultMessage:
      'If you don’t love it, we’ll pick it up and refund your money at no cost to you!',
  },
  yearWarranty10: {
    id: 'utils.yearWarranty10',
    defaultMessage: '10-Year Warranty',
  },
  yearWarranty5: {
    id: 'utils.yearWarranty5',
    defaultMessage: '5-Year Warranty',
  },
  yearWarranty1: {
    id: 'utils.yearWarranty1',
    defaultMessage: '1-Year Warranty',
  },
  dayTrial30: {
    id: 'utils.dayTrial30',
    defaultMessage: '30-Day Trial',
  },
  freeShippingAndReturns: {
    id: 'utils.freeShippingAndReturns',
    defaultMessage: 'Free Shipping & Returns',
  },
  freeShipping: {
    id: 'utils.freeShipping',
    defaultMessage: 'Free Shipping',
  },
  freeReturns: {
    id: 'utils.freeReturns',
    defaultMessage: 'Free Returns',
  },
  return30: {
    id: 'utils.return30',
    defaultMessage: '30-Day Return',
  },
  financingAvailable: {
    id: 'utils.financingAvailable',
    defaultMessage: 'Financing Available',
  },
});
